<div class="menu" *ngIf="_active">
  <div
    class="col-12 items"
    [ngClass]="{ last: index >= menus.length - 2 }"
    *ngFor="let blok of menus; let last = last; let index = index"
  >
    <div
      class="menu-label action"
      (click)="_menu = blok; clickout($event)"
    ></div>
    <div class="menu-label">
      <ndc-dynamic
        *ngIf="components"
        [ndcDynamicComponent]="components[blok.component]"
        [ndcDynamicInputs]="blok"
      >
      </ndc-dynamic>
    </div>
  </div>
</div>
